import {
    getItemFromCollection
} from "directus/src/operations";

export async function fetchDataOutcomesforForm({ id }) {
    try {
        const query = {
            fields: [
                "id",
                "description",
                "type",
                "case_study.id",
            ],
        };

        const response = await getItemFromCollection("outcomes", id, query);
        return response;
    } catch (error) {
        console.error(error);

        throw error;
    }
}